module.exports = __webpack_public_path__ + "img/dkweb-logo1.3636e4ad.png";